import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { PermissionFlags } from "../enums/permissionFlags.enum";
import {
    GridPermissions,
    gridToPermissionFlags,
} from "../shared/grid/core-grid/gridPermissions.enum";
import { PermissionService } from "../services/permission.service";

@Directive({
  standalone: false, selector: "[objectHasPermission]" })
export class ObjectHasPermissionDirective {
    private objectId: string = "";
    private action: GridPermissions = GridPermissions.Read;
    private lastPermission: boolean | undefined;

    constructor(
        private templateRef: TemplateRef<unknown>,
        private viewContainer: ViewContainerRef,
        private permissionService: PermissionService,
    ) {}

    @Input() set objectHasPermission(objectId: string) {
        this.objectId = objectId;
        this.updateView();
    }

    @Input() set objectHasPermissionAction(action: GridPermissions) {
        this.action = action;
        this.updateView();
    }

    private updateView(): void {
        const hasPermission = this.checkPermission();
        if (hasPermission === this.lastPermission) return;
        this.lastPermission = hasPermission;
        this.viewContainer.clear();
        if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private checkPermission(): boolean {
        const permFlags = [
            GridPermissions.Read,
            GridPermissions.Create,
            GridPermissions.Update,
            GridPermissions.Delete,
        ]
            .filter((gp) => (this.action & gp) !== 0)
            .reduce<PermissionFlags>(
                (acc, gp) => acc | gridToPermissionFlags[gp],
                0 as PermissionFlags,
            );

        return this.permissionService.hasPermissionFlag(
            this.objectId,
            permFlags,
        );
    }
}
